export default __webpack_public_path__ + "static/media/favourites.e549e25f.svg";